import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheMissionHub from "./sections/TheMissionHub";
import ImpactInNumbers from "./sections/ImpactInNumbers";
import LivesTransformed from "./sections/LivesTransformed";
import OurCoreInitiatives from "./sections/OurCoreInitiatives";
import ReadyToChangeALife from "./sections/ReadyToChangeALife";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TheMissionHub />
      <ImpactInNumbers />
      <LivesTransformed />
      <OurCoreInitiatives />
      <ReadyToChangeALife />
      <Footer />
    </div>;
}